module.exports = __webpack_public_path__ + "img/Wp_2086.dada2d62.png";